import { ErrorHandler, Injectable } from '@angular/core';
import { LoggingService } from '@core/services/logging.service';
import { PlatformService } from '@core/services/platform.service';

@Injectable()
export class CustomErrorHandlerService implements ErrorHandler {
    private readonly maxErrorCount: number = 10;
    private errorCount: number = 0;

    constructor(private logging: LoggingService, private platformService: PlatformService) {}

    /**
     * Implement Angular's error hook - Don't call this directly.
     * Captures internal angular errors.
     * @param error
     */
    public handleError(error: CustomError): void {
        if (typeof error !== 'object') {
            const exception = new Error('Custom Error');
            exception.message = error || 'No message';
            error = exception;
        }

        const type = 'AngularError';
        const platform = this.platformService.isBrowser ? 'BROWSER' : 'SERVER';

        if (this.errorCount < this.maxErrorCount) {
            if (this.logging.aiInstance) {
                this.logging.aiInstance.trackException({
                    exception: error,
                    properties: { platform, type }
                });
            }

            if (this.logging.sentryInstance) {
                error.platform = platform;
                error.type = type;
                this.logging.sentryInstance.captureException(error.originalError || error.error || error);
            }
            this.errorCount++;
        }

        if (
            this.logging.isDev ||
            this.logging.isVerbose ||
            (!this.logging.aiInstance && !this.logging.sentryInstance)
        ) {
            console.error(type, platform, error);
        }
    }
}

interface CustomError extends Error, Record<string, any> {
    platform?: string;
    type?: string;
}
